import { Component, HostListener, Input, OnInit } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { SessionService } from '../services/session.service';
import { Router } from '@angular/router';
import { ComunicacaoService } from '../services/comunicacao.service';

@Component({
  selector: 'app-sidenavbartop',
  templateUrl: './sidenavbartop.component.html',
  styleUrls: ['./sidenavbartop.component.css']
})
export class SidenavbartopComponent {
  @HostListener('window:unload', ['$event'])
  unloadHandler(event) {
    this.obs.unsubscribe();
  }
  @Input() sessao: any = null;
  public logado: Subject<boolean> = this.session.isLogado;
  mode: boolean;
  obs: Subscription;
  constructor(private session: SessionService,
    private router: Router,
    private comu: ComunicacaoService
  ) {
    this.comu.listen().subscribe((m: any) => {
      //mode == true barra sendo exibida, mode == false barra oculta
      if (m == 'hide-sidebar') {
        $('#nav_bar_top').removeClass('none');
      }
      else if (m == 'show-sidebar') {
        $('#nav_bar_top').addClass('none');
      }
    });

    this.obs = this.router.events.subscribe((events: any) => {
      if (events?.url) {
        $('#nav_bar_top').addClass('none');
      }
    });
  }


  toggleSideBar() {
    if ($('#nav_bar_top').hasClass('none'))
      $('#nav_bar_top').removeClass('none');
    else
      $('#nav_bar_top').addClass('none');
  }

  logoff() {
    this.session.clear();
    this.router.navigate(['/login/login-form']);
  }

  checkInGrupo(grupoIds = []) {
    return this.session.checkInGrupo(grupoIds);
  }

  isMaster() {
    return this.session.isMaster();
  }

  isCorporate() {
    let tipo = this.session.getTipoEmpresa();
    return tipo == 'CORPORATE';
  }

  isReguladora() {
    let tipo = this.session.getTipoEmpresa();
    return tipo == 'REGULADORA';
  }

  isOficina() {
    let tipo = this.session.getTipoEmpresa();
    return tipo == 'OFICINA';
  }

  allowRegisterOrcamento() {
    return this.checkInGrupo([1, 2, 3, 4, 5, 6, 7, 8]) && this.session.getPlanId() != undefined && !this.session.isMaster();
  }

}

